module.exports = __webpack_public_path__ + "static/bannerObject1-33d477bc2e881c1dcbb2ceb466087c1b.png";